import type { MsrGrundlagen } from './typen';
import { ContentSection, PropertyGrid, StatusBadge } from '../../muster';

/**
 * Der KI-Anbieter für die Funktionsbeschreibungen — nur Anzeige, keine
 * Auswahl (Konfiguration liegt in `deploy/.env`).
 *
 * Eigene, schlanke Komponente statt `koordination/KiAnbieter.tsx`: Deren
 * Props (`rueckfallmodell`, `rueckfallanbieter`) passen nicht zum
 * MSR-Vertrag (`{ anbieter, modell, rueckfall?, eingerichtet }`).
 */
export function KiAnbieter({ ki }: { ki: MsrGrundlagen['ki'] }) {
  return (
    <ContentSection
      titel="KI-Anbieter"
      beschreibung="Nur Anzeige — eingestellt wird der Anbieter in `deploy/.env`."
    >
      <PropertyGrid
        spalten={2}
        eintraege={[
          {
            beschriftung: 'Anbieter',
            wert: `${ki.anbieter}${ki.modell ? ` · ${ki.modell}` : ''}`,
          },
          ...(ki.rueckfall ? [{ beschriftung: 'Rückfall', wert: ki.rueckfall }] : []),
          {
            beschriftung: 'Eingerichtet',
            wert: ki.eingerichtet
              ? <StatusBadge klein zustand="gut" text="ja" />
              : <StatusBadge klein zustand="warnung" text="nein — kein Schlüssel hinterlegt" />,
          },
        ]}
      />
    </ContentSection>
  );
}
